import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { offers } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
import List from './list';

export const routes: RouteObject[] = [
  { path: 'offers', element: <ModuleLayout />,
    handle: { title: i18n.t('offers.title') },
    children: [
      { path: '', index: true, element: <List />,
        handle: { permission: 'offers:read', exclude: true },
      },
      { path: 'new', element: <Form />,
        handle: { title: i18n.t('offers.new'), permission: 'offers:create' },
      },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => offers.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (country: any) => (country && i18n.t('offers.edit', country)), permission: 'offers:update' },
      },
    ],
  },
];
